import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputComponent } from '../ngx-tel-input/ngx-intl-tel-input.component';
import { SearchPipe } from '../ngx-tel-input/search-pipe';
@NgModule({
    declarations: [
        NgxIntlTelInputComponent,
        SearchPipe,
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        FormsModule
    ],
    exports: [
        NgxIntlTelInputComponent
    ],
    providers: []
})
export class AppNgxTelInputModule { }
